import {convertLabelListToObjectList} from '../form-utils/Constants'
import {component} from '../form/Constant'
import {
    accommodationStatusList,
    diagnosticList,
    genderList,
    identityWithHeldReasonList,
    materialStatusList,
    patientKeys,
    patientOptionsList,
    religionList,
} from '../patient/PatientConstants'

export const titleHcpOptions = [
    {
        label: 'Doctor',
        value: 'doctor',
    },
    {
        label: 'Nurse',
        value: 'nurse',
    },
    {
        label: 'Carer',
        value: 'carer',
    },
]
export const healthCareList = [
    {
        key: patientKeys.hospitalInformation,

        description: 'Select the hospital HCP is assigned to',
        required: true,
        children: [
            {
                key: patientKeys.hospitalName,
                component: component.dropdown,
                options: [],
                required: true,
                placeholder: 'Select a hospital - Field is required',
            },
        ],
    },
    {
        key: patientKeys.roleInformation,

        description: 'Select a role associated with this HCP',
        required: true,
        children: [
            {
                key: patientKeys.role,
                component: component.dropdown,
                options: [],
                required: true,
                placeholder: 'Select a role - Field is required',
            },
        ],
    },
    {
        key: patientKeys.userAccount,
        required: true,
        description: ' Fill in the following information to create an account',
        note: 'The account will be sent to the patient via email after completing the form',
        children: [
            {
                key: patientKeys.username,
                component: component.inputText,
                placeholder: 'Auto-generated if leaving blank',
                keyFilter: true,
                defaultValue: '',
            },
            {
                key: patientKeys.email,
                component: component.inputText,
                required: true,
                keyFilter: true,
                placeholder: "Input HCP's email - Field is required",
                defaultValue: '',
            },
        ],
    },
    {
        key: patientKeys.basicInformation,
        description: 'Fill in the HCP information details',
        required: true,
        children: [
            {
                key: patientKeys.title,
                component: component.dropdown,
                options: titleHcpOptions,
                defaultValue: titleHcpOptions[0].value,
            },
            {
                key: patientKeys.firstName,
                component: component.inputText,
                required: true,
                placeholder: "Input HCP's first name - Field is required",
            },
            {
                key: patientKeys.lastName,
                component: component.inputText,
                placeholder: "Input HCP's last name",
            },
            {
                key: patientKeys.gender,
                component: component.dropdown,
                options: patientOptionsList.gender,
                defaultValue: genderList[0],
            },
            {
                key: patientKeys.dob,
                component: component.inputMask,
                placeholder: 'Input date of birth - Field is required',
                required: true,
                showTime: false,
            },
            {
                key: patientKeys.avatar,
                component: component.fileUpload,
            },
        ],
    },
    {
        key: 'contactInformation',
        description: 'Fill in the HCP contact details.',
        children: [
            {
                key: 'address',
                hideHeader: true,
                component: component.address,
                className: 'col-12 grid  px-0',
                childrenClassName: 'md:col-6 col-12 px-1',
            },
        ],
    },
]

export const hcpOptionsList = {
    title: [
        {label: 'Doctor', value: 'doctor'},
        {label: 'Nurse', value: 'nurse'},
        {label: 'Carer', value: 'carer'},
    ],
    gender: convertLabelListToObjectList(genderList),
    maritalStatus: materialStatusList,
    religion: religionList,
    accommodationStatus: accommodationStatusList,
    identityWithHeldReason: identityWithHeldReasonList,

    hospital: [],
    diagnostic: diagnosticList,
}

export const hcpKeys = {
    userAccount: 'userAccount',
    username: 'username',
    email: 'email',

    basicInformation: 'basicInformation',
    title: 'title',
    firstName: 'firstName',
    lastName: 'lastName',
    gender: 'gender',
    dob: 'dob',
    avatar: 'avatar',

    userStatus: 'userStatus',
    inactive: 'inactive',
    deleted: 'deleted',

    contactInformation: 'contactInformation',
    address: 'address',

    hospitalInformation: 'hospitalInformation',
    hospitalName: 'hospitalName',
    hospitalNumber: 'hospitalNumber',

    pathwayInformation: 'pathwayInformation',
    pathway: 'pathway',

    additionalInformation: 'additionalInformation',
    occupation: 'occupation',
    maritalStatus: 'maritalStatus',
    religion: 'religion',
    accommodationStatus: 'accommodationStatus',
    identityWithHeldReason: 'identityWithHeldReason',
    diagnostic: 'diagnostic',
    sickness: 'sickness',

    nokInformation: 'NOKInformation',
    nokFullName: 'NOKFullName',
    nokEmail: 'NOKEmail',
    nokDescription: 'NOKDescription',
    nokRelationShip: 'NOKRelationship',

    nokContactInformation: 'NOKContactInformation',
    nokAddress: 'address',
}
export const hcpFilterList = [
    {
        key: hcpKeys.basicInformation,
        children: [
            {
                key: hcpKeys.title,
                component: component.multiSelect,
                options: hcpOptionsList.title,
            },
            {
                key: hcpKeys.gender,
                component: component.multiSelect,
                options: hcpOptionsList.gender,
            },
        ],
    },
    {
        key: hcpKeys.contactInformation,
        children: [
            {
                key: hcpKeys.address,
                hideHeader: true,
                component: component.address,
            },
        ],
    },
    {
        key: hcpKeys.userStatus,
        children: [
            {
                key: hcpKeys.inactive,
                component: component.checkbox,
            },
            {
                key: hcpKeys.deleted,
                component: component.checkbox,
            },
        ],
    },
]

export const roleAssignKeys = {
    active: 'active',
    createdAt: 'createdAt',
    hospitalId: 'hospitalId',
    hospitalName: 'hospitalName',
    hospitalNumber: 'hospitalNumber',
    qualified: 'qualified',
    roleDescription: 'roleDescription',
    roleId: 'roleId',
    roleName: 'roleName',
}

export const roleAssignFormList = [
    {
        key: 'roleAssignInformation',
        description:
            'Assign new hospital and a new role to the health care professionals',
        children: [
            {
                key: 'hospitalName',
                component: component.dropdown,
                placeholder: 'Field is required',
                options: [],
            },
            {
                key: 'roleName',
                component: component.dropdown,
                placeholder: 'Field is required',
                options: [],
            },
            // {
            //     key: 'accessDuration',
            //     component: component.inputText,
            //     placeholder: 'Input access duration',
            // },
            // {
            //     key: 'timeLimited',
            //     component: component.checkbox,
            // },
        ],
    },
]

export const healthCarePractitionerHiddenColumns = [
    {key: 'dob'},
    {key: 'avatar'},
    {key: 'type'},
    {key: 'addressLine1'},
    {key: 'addressLine2'},
    {key: 'addressLine3'},
    {key: 'addressLine4'},
    {key: 'city'},
    {key: 'state'},
]

export const healthCareStaticlist = [
    {
        key: 'staticList',
        description:
            'Fill in the following information to create a static list',
        children: [
            {
                key: 'name',
                component: component.inputText,
                required: true,
                placeholder: "Input static list's name - Field is required",
            },
            {
                key: 'description',
                component: component.inputText,
                placeholder: 'A short description',
            },
            {
                key: 'patients',
                component: component.dropdown,
                options: [],
                placeholder: 'Select a patients to this static list',
                required: true,
            },
        ],
    },
]
